import { render, staticRenderFns } from "./Finalizadas.vue?vue&type=template&id=1e8bba44&scoped=true"
import script from "./Finalizadas.vue?vue&type=script&lang=js"
export * from "./Finalizadas.vue?vue&type=script&lang=js"
import style0 from "./Finalizadas.vue?vue&type=style&index=0&id=1e8bba44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8bba44",
  null
  
)

export default component.exports